module.exports = __webpack_public_path__ + "static/media/lupa_buscar.2c063471.svg";